import React, { useState } from "react";
import { useNavigate } from "react-router-dom";
import { config } from "../config";
import Header from "../components/Header";

function SearchBooking() {
  const navigate = useNavigate();
  const [bookingRef, setBookingRef] = useState("");
  const [email, setEmail] = useState("");

  const handleSearch = () => {
    // In a real app, we'd validate the booking reference and email
    navigate("/my/booking/AMT123456");
  };

  return (
    <div className="min-h-screen bg-gray-50">
      <Header />
      <div className="container mx-auto px-4 py-12">
        <div className="grid md:grid-cols-2 gap-8">
          <div>
            <h1 className="text-3xl font-bold mb-4">Manage your booking</h1>
            <p className="text-gray-600 mb-8">
              If you have an existing booking with us please enter your booking
              details below to get tailored advice
            </p>

            <div className="space-y-4">
              <div className="relative">
                <input
                  type="text"
                  placeholder="Booking reference"
                  value={bookingRef}
                  onChange={(e) => setBookingRef(e.target.value)}
                  className="w-full p-4 rounded-lg border border-gray-200 focus:outline-none focus:ring-2 focus:ring-purple-500"
                />
              </div>

              <input
                type="email"
                placeholder="Email address"
                value={email}
                onChange={(e) => setEmail(e.target.value)}
                className="w-full p-4 rounded-lg border border-gray-200 focus:outline-none focus:ring-2 focus:ring-purple-500"
              />

              <button
                onClick={handleSearch}
                className={`w-full bg-${config.primaryColor} text-white py-4 rounded-full hover:bg-purple-700 transition-colors text-lg font-semibold`}
              >
                Search
              </button>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}

export default SearchBooking;
